export const useBaseConfirmController = defineStore(
  "baseConfirmController",
  () => {
    const isOpen = ref(false);

    const title = ref("");
    const message = ref("");
    const isMessageComponent = ref(false);
    const confirmButtonLabel = ref("Yes");
    const cancelButtonLabel = ref("No");

    const savedResolver = ref<any>();
    const savedReject = ref<any>();

    const open = (options?: {
      resolver: any;
      reject: any;
      title?: string;
      message?: string;
      isMessageComponent?: boolean;
      confirmButtonLabel?: string;
      cancelButtonLabel?: string;
    }) => {
      isOpen.value = true;
      title.value = options?.title ?? "Confirm";
      message.value = options?.message ?? "Are you sure you want to proceed?";
      isMessageComponent.value = options?.isMessageComponent ?? false;
      confirmButtonLabel.value = options?.confirmButtonLabel ?? "Yes";
      cancelButtonLabel.value = options?.cancelButtonLabel ?? "No";

      savedResolver.value = options?.resolver;
      savedReject.value = options?.reject;
    };

    const close = () => {
      isOpen.value = false;
    };

    return {
      isOpen,
      title,
      message,
      isMessageComponent,
      confirmButtonLabel,
      cancelButtonLabel,
      open,
      close,
      savedResolver,
      savedReject,
    };
  }
);
